import { FC, ReactElement, useState } from 'react';

import classNames from 'classnames';

import {
	BUTTON_TYPES,
	ChevronDown,
	ChevronUp,
	EvButton,
	EvSvgIcon
} from '@evinced-private/ui-common';

import './LabelsPanel.scss';

interface ILabelsPanel {
	labels: string[];
}

export const LabelsPanel: FC<ILabelsPanel> = ({ labels }) => {
	const [isLabelPanelOpen, setIsLabelPanelOpen] = useState<boolean>(false);
	const toggleLabel = isLabelPanelOpen ? 'Collapse Labels Panel' : 'Expand Labels Panel';
	const numberOfLablesInLine = 3;
	const renderTestLables = (labels: string[]): ReactElement[] => {
		let labelsInLine = [];
		return labels.sort().map((label, index) => {
			const labelKeyValue = label.split(':');

			// create new line every numberOfLablesInLine labels (when remainder is 0)
			const newLine = index !== 0 && (index + 1) % numberOfLablesInLine === 0;

			// add label to be rendered in line
			labelsInLine.push(labelKeyValue);

			// if new line or last label - render labels line
			if (newLine || index === labels.length - 1) {
				const labelsLine = labelsInLine;
				labelsInLine = [];
				return (
					<li className="labels-line" key={label}>
						{labelsLine.map((value) => (
							<span className="test-label" key={`${label}-${value}-test-label`}>
								<span className="label-key">{`${value[0]} :`}</span>
								<span className="label-value">{value[1]}</span>
							</span>
						))}
					</li>
				);
			}
			return null;
		});
	};
	return (
		<div className="labels-panel">
			<ul className={classNames('test-labels', { open: isLabelPanelOpen })}>
				{renderTestLables(labels)}
			</ul>
			{labels.length > 9 && (
				<EvButton
					ariaLabel={toggleLabel}
					type={BUTTON_TYPES.ICON}
					onClick={() => setIsLabelPanelOpen(!isLabelPanelOpen)}
				>
					{isLabelPanelOpen ? 'Show less' : 'Show more'}
					<span className="chevron-icon" aria-hidden="true">
						<EvSvgIcon icon={isLabelPanelOpen ? ChevronUp : ChevronDown} isSmall />
					</span>
				</EvButton>
			)}
		</div>
	);
};
